import WcIcon from '@mui/icons-material/Wc';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import LoginIcon from '@mui/icons-material/Login';
import InfoIcon from '@mui/icons-material/Info';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AtmIcon from '@mui/icons-material/Atm';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import PlaceIcon from '@mui/icons-material/Place';

// Visual + label metadata for each landmark `kind`. Add new entries here when
// admins start using new kinds; unknown kinds fall back to a generic Place
// pin so the map never breaks.
export const LANDMARK_META = {
  restroom:  { label: 'Restrooms',         color: '#5c6bc0', Icon: WcIcon },
  food:      { label: 'Food',              color: '#ef6c00', Icon: RestaurantIcon },
  kids_zone: { label: 'Kids Zone',         color: '#43a047', Icon: ChildCareIcon },
  entrance:  { label: 'Entrance',          color: '#2e7d32', Icon: LoginIcon },
  info:      { label: 'Information',       color: '#0288d1', Icon: InfoIcon },
  parking:   { label: 'Parking',           color: '#455a64', Icon: LocalParkingIcon },
  first_aid: { label: 'First Aid',         color: '#c62828', Icon: LocalHospitalIcon },
  atm:       { label: 'ATM',               color: '#6d4c41', Icon: AtmIcon },
  stage:     { label: 'Stage',             color: '#7b1fa2', Icon: TheaterComedyIcon },
  other:     { label: 'Point of Interest', color: '#616161', Icon: PlaceIcon },
};

export const getLandmarkMeta = (kind) => LANDMARK_META[kind] || LANDMARK_META.other;

// Ordered list of the well-known landmark kinds. Used by the admin editor's
// "Add landmark" dialog so the dropdown shows the recognized icons first.
// Admins can still type a custom kind; unknown kinds fall back to the generic
// pin via getLandmarkMeta.
export const KNOWN_LANDMARK_KINDS = [
  'restroom',
  'food',
  'kids_zone',
  'entrance',
  'info',
  'parking',
  'first_aid',
  'atm',
  'stage',
  'other',
];
